module.exports = __webpack_public_path__ + "static/media/mentoralas.1a2ba5eb.png";